<form
  *ngIf="isEditable; else counterValue"
  name="counter"
  class="input-counter {{ formClass }}">
  <div class="incrementers">
    <span
      class="increment-major"
      (click)="decreaseMajor($event)"
      >-</span
    >
    <span
      *ngIf="enableMinors"
      class="increment-minor"
      (click)="decreaseMinor($event)"
      >-</span
    >
  </div>
  <span class="counter-wrap">
    <input
      type="text"
      class="input-count {{ isDecimal ? 'decimal' : '' }}"
      name="count"
      [maxLength]="maxLength ? maxLength : 9999"
      [ngModel]="_formatDisplayValue(initialValue)"
      (ngModelChange)="onManualInput($event)"
      mask="{{ disableMask ? null : isDecimal ? 'separator.2' : '0*' }}"
      [allowNegativeNumbers]="allowNegative"
      (click)="$event.stopPropagation()" />
  </span>
  <div class="incrementers">
    <span
      class="increment-major"
      (click)="increaseMajor($event)"
      >+</span
    >
    <span
      *ngIf="enableMinors"
      class="increment-minor"
      (click)="increaseMinor($event)"
      >+</span
    >
  </div>
</form>

<ng-template #counterValue>{{
  _formatDisplayValue(initialValue) ? _formatDisplayValue(initialValue) : '-'
}}</ng-template>
